import { useService } from "@providersV2";
import { CourseService } from "@servicesV2";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { z } from "zod";

export type CourseServiceProviderParams = {
  courseId?: string;
  learnerId?: string;
  enabled?: boolean;
};

export function useCourseProvider(params?: CourseServiceProviderParams) {
  const { courseId: routeCourseId } = useParams();

  const courseId = params?.courseId ?? z.string().parse(routeCourseId);
  const learnerId = params?.learnerId;
  const enabled = params?.enabled ?? true;

  const { initialization: courseServiceInit } = useService(CourseService);

  return useQuery({
    queryKey: ["courses", courseId, learnerId],
    enabled,

    queryFn: async () => {
      const { service: courseService } = await courseServiceInit;
      return courseService.getCourseById(courseId, learnerId);
    },

    refetchInterval: ({ state: { data } }) => {
      if (!data || !("progress" in data)) return false;

      const { progress } = data;

      return progress.userCompletionOn && !progress.completionCertificateFileId
        ? 3000
        : false;
    },
  });
}
